import { inject, injectable } from 'tsyringe';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type ISurveyForAgentRepository } from 'application/repositorySchemas/ISurveyForAgentRepository';
import { type IAnswerSurveyForAgentClient } from 'interfaceAdapter/gatewaySchemas/IAnswerSurveyForAgentClient';

@injectable()
export class SurveyForAgentRepository implements ISurveyForAgentRepository {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAnswerSurveyForAgentClient')
        public readonly answerSurveyClient: IAnswerSurveyForAgentClient,
    ) {}

    public async answer(matchId: number, answers: Array<number | string | null>) {
        const { data, message } = await this.answerSurveyClient.post({
            token: this.agentUserToken.get() || '',
            matchId,
            answers,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
